import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Table, { ColumnDefinitionType } from '../../../../components/Table'
import Paginacion from "../../../../components/Paginacion";
import { useEquipamiento } from "../../../../hooks/useEquipamiento";
import { Equipamiento } from "../../../../types/Equipamiento";
import { Loading } from "../../../../components/Loading";
import Confirm from "../../../../components/Confirm";

const TableEquipamiento = () => {
    const { equipamientoList, loading, filtro, paginacion, buscarEquipamientos, eliminarEquipamiento } = useEquipamiento();
    const [aEliminar, setAEliminar] = useState<Equipamiento | null>(null);

    // Vuelve a pedir la página actual; si la baja dejó vacía la última página, retrocede una.
    const refrescar = async () => {
        const pagina = await buscarEquipamientos(filtro, paginacion.page, paginacion.size);
        if (pagina && pagina.content.length === 0 && paginacion.page > 0) {
            await buscarEquipamientos(filtro, paginacion.page - 1, paginacion.size);
        }
    }

    const eliminar = () => {
        const equipamiento = aEliminar;
        setAEliminar(null);
        if (!equipamiento) {
            return;
        }
        eliminarEquipamiento(equipamiento.id)
            .then(() => toast.success("Se dio de baja el Equipamiento correctamente"))
            .catch((err) => toast.error(err?.response?.data?.message ?? "Hubo un error al eliminar el Equipamiento"))
            .finally(refrescar);
    }

    const columns: ColumnDefinitionType<Equipamiento, keyof Equipamiento>[] = [
        {
            key: 'nombre',
            header: 'Nombre',
        },
        {
            key: 'descripcion',
            header: 'Descripción',
        },
        {
            key: 'activo',
            header: 'Estado',
            cell: (data: Equipamiento) => <>{data.activo ? 'Activo' : 'Inactivo'}</>
        },
        {
            key: 'id',
            header: 'Acciones',
            cell: (data: Equipamiento) =>
                <>
                    <Link to={`/equipamiento/editar/${data.id}?action=view`} title="Visualizar">
                        <i className="fa fa-eye text-secondary me-2" aria-hidden="true"></i>
                    </Link>
                    <Link to={`/equipamiento/editar/${data.id}`} title="Editar">
                        <i className="fa fa-pencil text-custom" aria-hidden="true"></i>
                    </Link>
                    {data.activo &&
                        <Link to="#" title="Eliminar" onClick={(e) => { e.preventDefault(); setAEliminar(data); }}>
                            <i className="fa fa-trash-o mr-2 text-danger" aria-hidden="true"></i>
                        </Link>
                    }
                </>
        },
    ]

    return (
        <>
            <Confirm isOpen={aEliminar !== null} toggle={() => setAEliminar(null)} title='Eliminar' yesFn={eliminar}>
                <div className="form-horizontal">
                    <div className="row">
                        <p>Está seguro que desea eliminar el Equipamiento {aEliminar?.nombre}?</p>
                    </div>
                </div>
            </Confirm>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ibox float-e-margins">
                                <div className="ibox-title">
                                    <h4 className="m-t-0 header-title">
                                        <i className="fa fa-list-ul" aria-hidden="true" style={{ marginRight: "5px" }}></i>
                                        Listado de Equipos
                                        <Link to={`/equipamiento/nuevo`} title="Nuevo" className="btn-custom btn-rounded waves-effect waves-light pull-right btn-sm" style={{ marginTop: '-8px' }}>
                                            <i className="fa fa-plus margin-right-10"></i> Nuevo
                                        </Link>
                                    </h4>
                                </div>

                                <div className="table-responsive">
                                    <br />
                                    {loading ? <Loading /> : <Table data={equipamientoList || []} columns={columns}></Table>}
                                </div>

                                <Paginacion
                                    page={paginacion.page}
                                    size={paginacion.size}
                                    totalElements={paginacion.totalElements}
                                    totalPages={paginacion.totalPages}
                                    onPageChange={(page) => buscarEquipamientos(filtro, page, paginacion.size)}
                                    onSizeChange={(size) => buscarEquipamientos(filtro, 0, size)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TableEquipamiento;
